import { SearchResponseItem } from './search-response-item.model';

export class SearchResponse {
    constructor(public results: SearchResponseItem[], public searchDate: Date) {
    }
}
